<template>
  <div class="step-outer-box">
    <div class="bottom-all-box">
      <div class="tip-message" v-if="is_submit">
        <template v-if="approve_status == 3">教师已评分，不支持修改作业。</template>
        <template v-else>作业已上传：请等待教师评分，在教师评分后不支持修改作业</template>
      </div>
      <div class="task-wrapper">
        <div class="profile-item has-file" v-if="task_description||workFile.length">
          <div class="profile-label">任务说明</div>
          <div class="profile-content">
            <div class="text-scroll" v-html="task_description"></div>
            <div class="files" v-if="workFile && workFile.length > 0">
              <div class="file-label">作业<br>附件</div>
              <div class="profile-files">
                <div class="file-item" v-for="item,index in workFile" :key="index">
                  <div class="file-name">
                    <a-tooltip overlayClassName="intro-tooltip-box" placement="bottom">
                      <template slot="title">
                        附件{{`${index+1}：`}}{{item.filename}}.{{item.file_format}}
                      </template>
                      附件{{`${index+1}：`}}{{item.filename}}.{{item.file_format}}
                    </a-tooltip>
                  </div>
                  <div class="file-button">
                    <div class="button-item" @click="previewRes(item)">查看</div>
                    <div class="button-item" @click="downloadRes(item,1)">下载</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="profile-item" v-if="exampleFile&&exampleFile.length">
          <div class="profile-label">参照样例</div>
          <div class="profile-files">
            <div class="file-item" v-for="(item, index) in exampleFile" :key="index">
              <div class="file-name">
                <a-tooltip overlayClassName="intro-tooltip-box" placement="bottom">
                  <template slot="title">
                    {{item.filename}}.{{item.file_format}}
                  </template>
                  {{item.filename}}.{{item.file_format}}
                </a-tooltip>
              </div>
              <div class="file-button">
                <div class="button-item" @click="previewRes(item)">查看</div>
                <div class="button-item" @click="downloadRes(item,1)">下载</div>
              </div>
            </div>
          </div>
        </div>

        <div class="second-line">任务提交</div>

        <div class="step-line">第一步：请输入选择线下参加的实践基地点位</div>

        <div class="filter-box user-select">
          <div class="filter-label">请选择基地点位：</div>
          <div class="filter-content" :class="{disabled:approve_status == 3}">
            <div class="con-first">
              <div class="placeholder">请输入基地名称搜索</div>
              <a-select show-search mode="multiple" placeholder="请输入基地名称搜索" option-filter-prop="children" style="width: 420px" class="multiple-select" dropdownClassName="multipleDrop user-select" v-model="selectedHubsArr">
                <a-select-option v-for="(item, index) in hubsArr" :key="index" :value="item.name">{{ item.name }}</a-select-option>
              </a-select>
              <div class="filter-tips error-message" v-if="showError && [...selectedHubsArr,...pointArr].length == 0">请选择至少一个基地点位</div>
            </div>
            <div class="con-second">
              <div v-for="item,index in [...selectedHubsArr,...pointArr]" :key="index" class="address-item">{{item}} <span @click="deletePoint(item,index)" class="del-icon"></span></div>
              <div v-show="showPointInput" class="input-line">
                <input ref="addInput" class="add-input" v-model="pointName" type="text" @keyup.enter="handlePointEnter" @blur="handlePointEnter('blur')" placeholder="请输入基地名称" />
              </div>
              <div class="add-btn" @click="addPoint">+ 添加实践基地点位</div>
            </div>
          </div>
        </div>

        <div class="step-line">第二步：完成任务</div>

        <div class="step-content">
          <div class="step-upload" :class="{disabled:approve_status == 3}">
            <a-upload name="file" :customRequest="handleUpload" :multiple="true" :showUploadList="false" :accept="'.png,.jpeg,.jpg'" class="file-upload">
              <div class="file-handle">
                <a-button type="button">上传文件</a-button>
              </div>
            </a-upload>
            <div class="upload-text">
              格式要求:您可以上传.png、.jpeg、.jpg格式，不超过30MB的文件。
            </div>
          </div>

          <!-- 文件列表 -->
          <div class="file-list" v-if="fileList&&fileList.length > 0">
            <!-- 图片、音频类型不需要显示转码状态   covert_status 转码 1 2 3 进行中 已完成 上传中-->
            <div v-for="(file, index) in fileList" :key="index" :class="['file-item',(file.type == 3||file.type==4)&&file.covert_status == 2?'translate':'',file.status == 'uploading'?'uploading':'']">
              <div class="file-upper">
                <!-- 文件封面 docx显示默认封面 -->
                <div class="file-cover" :class="{ 'file-docx': file.type == 4 }" :style="(file.type == 1 || (file.type == 3&&file.covert_status == 2)) ? `background:url(${file.cover||file.view_url}) no-repeat center/cover` : ''">
                </div>
                <!-- 删除附件 -->
                <div class="file-delete" @click="removeFile(index)" :class="{disabled:approve_status == 3}"></div>
                <div class="file-mask">
                  <!-- 上传进度 -->
                  <div class="file-progress" v-if="file.status == 'uploading'">
                    <a-progress type="circle" :percent="file.progress" :width="40" strokeColor="#B84B3C" trailColor="#E3E4E9" />
                  </div>
                  <div class="file-button" v-else-if="(file.type == 1 || file.covert_status == 2)">
                    <!-- 预览 -->
                    <div class="file-preview" @click="previewRes(file)">预览</div>
                    <template v-if="file.id">
                      <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                      <!-- 下载 -->
                      <div class="file-download" @click="downloadRes(file,2)">下载</div>
                    </template>
                  </div>
                </div>

                <!-- 转码中 如果状态不是在上传中 & 附件不是图片、音频 & 不是转码中-->
                <div :class="['file-translate',file.translate?'translate':'']" v-if="(file.status != 'uploading')&&file.type != 1 && file.type != 2 && file.covert_status == 1">
                </div>
              </div>
              <!-- 附件名称 -->
              <div class="file-name">
                <a-popover v-if="file.filename&&file.filename.length > 28" placement="bottom">
                  <template slot="content">
                    <div>{{ file.filename + ( file.file_format ? '.' + file.file_format : '' ) }}</div>
                  </template>
                  <div class="name-txt">{{ file.filename + ( file.file_format ? '.' + file.file_format : '' ) }}</div>
                </a-popover>
                <div v-else class="name-txt">{{ file.filename + ( file.file_format ? '.' + file.file_format : '' ) }}</div>
              </div>
            </div>
          </div>
          <div class="file-empty error-message" v-else-if="showError &&fileList.length==0">请上传至少一个文件</div>
        </div>

        <div class="submit-box">
          <div :class="{disabled:approve_status == 3}" class="submit-btn" @click="beforeSubmitTask()">提交作业</div>
        </div>
        <div class="level-line">作业提交记录</div>
        <div class="level-table-box">
          <a-table class="level-small-table" :columns="columns" :data-source="data" rowKey="id" :bordered="false" size="small" :pagination="false" />
        </div>
      </div>

    </div>

    <component :is="dialogConfig.name" :dialogConfig="dialogConfig"></component>
    <!-- 下载进度 -->
    <a-spin :tip="`下载中 ${downloadProgress}% ...`" :spinning="loading">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    </a-spin>
    <!-- 确认提交框 -->
    <CommonModal v-model="submitVisible" title="提交作业" confirmText="确定" @confirm="submitTask()">
      <div>
        确定提交吗？
      </div>
    </CommonModal>
    <a-spin :spinning="isRequest" tip="提交中">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    </a-spin>

  </div>
</template>

<script>
import services from '../../../../assets/js/services';
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
import { downloadFile, downloadVideoFile, getDownloadUrl } from '../../../../assets/js/downloadUtils'; // 引入封装的方法
import CommonModal from "../../../../components/CommonModal.vue"
import imageViewer from '../../../../assets/js/imageViewer';
export default {
  name: "unitThree",
  data () {
    return {
      services,
      dialogConfig: {
        type: "",
        name: "",
        fileId: "",
        path: "",
        title: "",
      },
      pointArr: [], // 添加的基地集合
      showPointInput: false, // 基地名称添加的input
      pointName: '',//基地名称
      text: "不忘初心、牢记使命、坚持党的全面领导",
      data: [], // 提交记录表格数据
      columns: [
        {
          title: "提交人姓名",
          dataIndex: "name",
        },
        {
          title: "账号",
          dataIndex: "username",
        },
        {
          title: "手机号",
          dataIndex: "mobile",
        },
        {
          title: "提交时间",
          dataIndex: "created_at",
        },
      ],
      submitVisible: false,
      exampleFile: [], // 参照样例
      workFile: [],//作业附件
      fileList: [], // 上传的附件列表
      task_description: '', // 任务说明
      limitSize: 1024 * 1024 * 30, // 最大上传1G
      limitText: "30MB",// 超出限制提示文本
      approve_status: "", // 评分状态1待评分2系统评分3教师评分,教师已评分不允许提交
      selectedHubsArr: [], // 已选择的基地点位
      hubsArr: [],//基地点位
      downloadProgress: 0,
      loading: false,
      showError: false, // 是否显示错误提示
      is_submit: false, // 是否已经提交过
      isRequest: false, // 是否提交中
    };
  },
  components: {
    PreviewPdf: () => import('../../../../components/PreviewPdf'),
    PlayBox: () => import('../../../../components/PlayBox'),
    CommonModal
  },
  mounted () {
    this.getTaskData()
    this.getT006Hub()
  },
  methods: {
    async getTaskData () {
      let query = this.$route.query
      let params = { code: "t006", activity_id: query.activity_id, course_id: query.course_id }
      let result = await services.getCenterTaskData(params)
      if (result.code == '0000') {
        this.data = result.data.work.work_records || []
        this.fileList = result.data.work.work_attachments || []
        this.fileList.forEach(item => {
          if (item.covert_status == 1) item.translate = true
        })
        this.exampleFile = result.data.course_resourses.filter(item => item.is_model == 2)
        this.workFile = result.data.course_resourses.filter(item => item.is_model == 1)
        this.task_description = result.data.task_description
        this.approve_status = result.data.work.approve_status || ""
        this.selectedHubsArr = result.data.work.hub && result.data.work.hub.split(",") || []
        this.is_submit = !!result.data.work.id; // 是否提交过
      }
    },
    async getT006Hub () {
      let params = {
        page: 1,
        size: -1, // 不分页-1
        course_id: this.$route.query.course_id
      }
      let result = await services.getCenterT006Hub(params)
      if (result.code == "0000") {
        this.hubsArr = result.data.items
      }
    },
    // 回车添加基地
    handlePointEnter (blur) {
      if (this.pointName) this.pointName = this.pointName.trim()
      if (!this.pointName || !this.pointName.trim()) {
        if (blur) return this.showPointInput = false
        this.$message.error("请输入基地名称")
        this.pointName = ''
      } else if (this.pointArr.indexOf(this.pointName) > -1 || this.selectedHubsArr.indexOf(this.pointName) > -1) {
        this.$message.error("基地名称已存在")
      } else {
        this.pointArr.push(this.pointName)
        this.pointName = ''
        this.showPointInput = false
      }
    },
    addPoint () {
      this.showPointInput = true; // 显示输入框
      this.$nextTick(() => {
        this.$refs.addInput.focus(); // 聚焦到输入框
      });
    },
    // 删除基地点位
    deletePoint (item) {
      let ind = this.selectedHubsArr.findIndex(i => i == item)
      let piIndex = this.pointArr.findIndex(i => i == item)
      if (ind >= 0) {
        this.selectedHubsArr.splice(ind, 1)
      } else {
        this.pointArr.splice(piIndex, 1)
      }
    },

    beforeSubmitTask () {
      let hub = [...this.pointArr, ...this.selectedHubsArr].join(",")
      if (this.approve_status == 3) return this.$message.info("教师已评分，不允许修改")
      this.showError = true
      this.$nextTick(() => {
        const errorElement = document.querySelector('.error-message');
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        if (hub.length == 0) return this.$message.info("请选择至少一个基地点位")
        if (this.fileList.length == 0) return this.$message.info("请上传至少一个文件")

        // console.log(this.fileList)
        let isUploading = false
        for (let i = 0; i < this.fileList.length; i++) {
          if (this.fileList[i].status == 'uploading') {
            isUploading = true
            break;  // 找到目标值后退出循环
          }
        }
        if (isUploading) return this.$message.info("请等待文件上传完成后再次提交")

        this.submitVisible = true
      })

    },
    async submitTask () {
      if (this.isRequest) return this.$message.info("请等待提交完成后再次提交")
      this.isRequest = await true
      let query = this.$route.query
      let work_attachments = JSON.stringify(this.fileList.map((item => {
        let data = {
          filename: item.filename,
        }
        if (item.id) data["id"] = item.id
        if (item.fileId) data["file_id"] = item.fileId
        if (item.type != 3) data["path"] = item.path
        return data
      })))
      let params = {
        code: "t006",
        activity_id: query.activity_id,
        course_id: query.course_id,
        hub: [...this.pointArr, ...this.selectedHubsArr].join(","),
        work_attachments,
      }
      this.submitVisible = false
      let result = await services.submitT005(params)
      if (result.code == "0000") {
        this.$message.success("提交成功")
        this.getTaskData()
        this.getT006Hub()
      } else {
        this.$message.error(result.message)
      }
      this.isRequest = await false
    },
    handleUpload ({ file }) {
      let that = this
      if (file.size > that.limitSize) return that.$message.info(`请上传不超过${that.limitText}的文件`)
      let type = that.getFileType(file.type)

      // let fileIndex = that.fileList.length
      let fileTime = new Date().getTime()
      // 加入附件列表
      that.fileList.push({
        fileTime,
        filename: file.name, // 附件名称
        type, // 附件类型
        covert_status: type == 1 ? 2 : 1,// 默认转码未完成(图片类型不需要转码,默认转码成功)
        progress: 0, // 上传进度
        status: 'uploading', // 默认状态上传中
        view_url: type == 1 ? URL.createObjectURL(file) : "",
      })

      // 其他类型上传
      const chunkSize = 1024 * 1024 * 3; // 3MB
      const totalChunks = Math.ceil(file.size / chunkSize); // 计算文件总片数
      const uuid = uuidv4() // 文件唯一标识
      let currentChunk = 0; // 当前上传的分片索引
      let uploadedBytes = 0; // 已上传的总字节数

      function uploadChunk () {
        const start = currentChunk * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const data = file.slice(start, end);
        const formData = new FormData();
        formData.append("file", data, file.name);
        formData.append("label", "T006");
        formData.append("is_tmp", "1");
        formData.append("uuid", uuid);
        formData.append("chunks", totalChunks);
        formData.append("chunk", currentChunk);
        // 发送分片数据
        axios.post(`${services.HOST}/api/upload/file`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            const chunkUploadedBytes = progressEvent.loaded;
            uploadedBytes = currentChunk * chunkSize + chunkUploadedBytes;
            // 更新上传进度
            let percent = Math.round((uploadedBytes / file.size) * 100);
            let index = that.fileList.findIndex(item => item.fileTime == fileTime)
            if (index > -1 && percent > that.fileList[index].progress) {
              that.fileList[index].progress = Math.round((uploadedBytes / file.size) * 100);
            }
          }
        }).then(({ data: result }) => {
          if (currentChunk < totalChunks - 1) {
            // 继续上传下一片
            currentChunk++;
            uploadChunk();
          } else {
            let index = (that.fileList.findIndex(item => item.fileTime == fileTime))
            if (result.code == "0000") {
              that.$message.success(result.message)
              that.$set(that.fileList, index, {
                ...that.fileList[index],
                progress: 100,
                status: 'success',
                view_url: result.data.url,
                path: result.data.path
              })
            } else {
              that.$message.error(result.message)
              that.removeFile(index)
            }

          }
        }).catch((error) => {
          console.error("上传失败", error);
        });
      }

      // 开始上传第一片
      uploadChunk();
    },
    // 获取文件类型
    getFileType (fileType) {
      if (fileType.includes("image")) return "1";
      if (fileType.includes("video")) return "3";
      return "4"; // 默认是文档
    },

    // 删除附件
    removeFile (index) {
      this.fileList.splice(index, 1);
    },
    // 下载附件
    async downloadRes (row, downloadType) {
      try {
        this.loading = true;
        this.downloadProgress = 0;

        if (downloadType === 1) {
          // 课程资源下载
          if (row.type == 3) {
            // 视频文件下载
            await downloadVideoFile(row.url, row.filename + (row.file_format ? '.' + row.file_format : ''), (progress) => {
              this.downloadProgress = progress;
            });
          } else {
            const downloadUrl = await getDownloadUrl("/api/center/train/course/resource/download", {
              id: row.id,
              course_id: this.$route.query.course_id,
            }, (progress) => {
              this.downloadProgress = progress;
            });
            await downloadFile(downloadUrl, row.filename + (row.file_format ? '.' + row.file_format : ''), (progress) => {
              this.downloadProgress = progress;
            });
          }
        } else {
          // 作业附件下载
          if (row.type != 1 && row.type != 2 && row.covert_status == 1) {
            return this.$message.error("请等待转码完成后下载");
          }
          if (row.type == 3) {
            // 视频文件
            await downloadVideoFile(row.url, row.filename + (row.file_format ? '.' + row.file_format : ''), (progress) => {
              this.downloadProgress = progress;
            });
          } else {
            const downloadUrl = await getDownloadUrl("/api/center/train/work/attachment/download", {
              id: row.id,
              activity_id: this.$route.query.activity_id,
            }, (progress) => {
              this.downloadProgress = progress;
            });
            await downloadFile(downloadUrl, row.filename + (row.file_format ? '.' + row.file_format : ''), (progress) => {
              this.downloadProgress = progress;
            });
          }
        }
      } catch (error) {
        console.error("下载失败", error);
        this.$message.error("下载失败");
      } finally {
        this.loading = false;
      }
    },
    // 预览资源
    previewRes (item) {
      if (item.type != 1 && item.type != 2 && item.covert_status == 1) return this.$message.info("请等待转码完成后预览")
      if (item.type != 1 && item.type != 2 && item.covert_status == 3) return this.$message.info("转码失败")
      this.dialogConfig.title = item.filename + "." + item.file_format
      this.dialogConfig.type = item.type
      if (item.type == 1) {
        imageViewer.open(item.view_url)
      } else if (item.type == 2 || item.type == 4) {
        // 图片/音频/文档
        this.dialogConfig.path = item.view_url;
        this.dialogConfig.name = 'PreviewPdf';
      } else {
        // 视频
        this.dialogConfig.fileId = item.file_id
        this.dialogConfig.name = 'PlayBox';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.step-outer-box {
    width: 100%;
    background: #ffffff;
    .bottom-all-box {
        border: 1px solid #e7eaec;
        border-top: 0;
        position: relative;
        overflow-y: auto;
        height: calc(100vh - 200px);
        min-height: 700px;
        .task-wrapper {
            padding-left: 25px;
            padding-right: 25px;
        }
        .tip-message {
            width: 100%;
            height: 40px;
            background: linear-gradient(90deg, #dfa267 0%, #d2b48c 100%);
            font-weight: bold;
            font-size: 14px;
            color: #ffffff;
            text-align: center;
            line-height: 40px;
            margin-bottom: 18px;
            &::before {
                content: '';
                display: inline-block;
                width: 13px;
                height: 13px;
                background: url('../../../../assets/image/student/stepFour/unitFour/tip.png')
                    no-repeat center/cover;
                margin-right: 9px;
                vertical-align: -2px;
            }
        }
        .submit-box {
            width: 100%;
            position: sticky;
            bottom: 0;
            left: 0;
            z-index: 10;
            padding: 20px 25px;
            text-align: center;
            border-top: 1px solid #ebedef;
            background: #ffffff;
            box-sizing: border-box;
            .submit-btn {
                cursor: pointer;
                margin: 0 auto;
                width: 88px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                background: #a82822;
                font-size: 14px;
                color: #ffffff;
            }
        }
    }

    .profile-item {
        display: flex;
        &.has-file {
            .profile-content {
                max-height: unset;
                padding-bottom: 8px;
            }
            .text-scroll {
                max-height: 115px;
                overflow-y: auto;
            }
            .files {
                display: flex;
                margin-top: 8px;
                background: #fff;
                padding: 5px 15px 5px 0;
                .file-label {
                    width: 44px;
                    height: 38px;
                    background: url('../../../../assets/image/school/teach/work-file.png')
                        no-repeat center/cover;
                    font-size: 12px;
                    color: #ffffff;
                    padding: 5px 0 0 7px;
                    line-height: 1.2;
                    margin-right: 15px;
                    flex-shrink: 0;
                }
                .profile-files {
                    padding: 0;
                    background: transparent;
                    .file-item {
                        width: 50%;
                        .file-name {
                            font-size: 12px;
                            color: #4f4f58;
                        }

                        .file-button {
                            .button-item {
                                font-size: 12px;
                                color: #dfa267;
                            }
                        }
                        &::after {
                            margin: 0 15px;
                        }
                        &:nth-child(3n)::after {
                            display: block;
                        }

                        &:nth-child(2n)::after {
                            display: none;
                        }
                    }
                }
            }
        }
        &:not(:last-child) {
            margin-bottom: 14px;
        }
        .profile-label {
            width: 86px;
            height: 30px;
            background: #bc7a6e;
            border-radius: 14px 0px 0px 14px;
            line-height: 30px;
            font-weight: bold;
            font-size: 14px;
            color: #ffffff;
            padding: 0 14px;
        }
        .profile-content {
            flex: 1;
            background: #fcf2f0;
            border-radius: 4px;
            font-size: 14px;
            color: #2f2626;
            line-height: 20px;
            min-height: 30px;
            height: max-content;
            padding: 5px 14px;
            max-height: 120px;
            overflow-y: auto;
        }
        .profile-files {
            flex: 1;
            background: #f8f8f8;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            padding: 5px 16px 0;
            max-height: 82px;
            overflow-y: auto;
            .file-item {
                width: calc(100% / 3);
                display: flex;
                align-items: center;
                margin-bottom: 5px;
                &:nth-child(3n)::after {
                    display: none;
                }
                &::after {
                    content: '';
                    display: inline-block;
                    width: 1px;
                    height: 16px;
                    background: #e8e4e4;
                    margin: 0 16px 0 21px;
                }
                .file-name {
                    font-size: 14px;
                    color: #606163;
                    flex: 1;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    padding-right: 10px;
                }
                .file-button {
                    display: flex;
                    align-items: center;
                    .button-item {
                        cursor: pointer;
                        &:not(:last-child) {
                            margin-right: 24px;
                        }
                        font-size: 14px;
                        color: #b84b3c;
                    }
                }
                &:last-child::after {
                    opacity: 0;
                }
            }
        }
    }
    .second-line {
        height: 32px;
        line-height: 32px;
        background: #b84b3c;
        margin-bottom: 14px;
        padding-left: 15px;
        font-weight: bold;
        font-size: 14px;
        color: #ffffff;
    }
    .step-line {
        font-weight: 400;
        font-size: 14px;
        color: #984236;
        padding-left: 15px;
        height: 30px;
        line-height: 30px;
        position: relative;
        z-index: 2;
        margin-bottom: 14px;
        &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 1;
            background: linear-gradient(
                90deg,
                #f0b465 0%,
                rgba(250, 205, 145, 0) 100%
            );
            opacity: 0.28;
        }
    }
    .filter-box {
        display: flex;
        padding: 0 15px 20px;
        .filter-label {
            font-weight: 400;
            font-size: 14px;
            color: #373536;
            line-height: 30px;
        }
        .filter-tips {
            font-weight: 400;
            font-size: 14px;
            color: #d50715;
            padding-left: 15px;
            display: inline-block;
            &::before {
                content: '';
                width: 14px !important;
                height: 14px !important;
                display: inline-block;
                margin-right: 5px;
                background-image: url('../../../../assets/image/student/stepFour/unitThree/tips.png') !important;
                background-size: cover;
                vertical-align: -2px;
            }
        }
        .filter-content {
            flex: 1;
            position: relative;
            .multiple-select {
                /deep/ .ant-select-selection-selected-value {
                    font-weight: bold;
                    font-size: 14px;
                    color: #8b3c22;
                }
                /deep/ .ant-select-selection {
                    min-height: 32px;
                    border-radius: 0;
                    line-height: 32px;
                    border-color: #dbdad8 !important;
                    border-right-width: 1px !important;
                    box-shadow: none !important;
                }
                /deep/ .ant-select-selection__placeholder,
                .ant-select-search__field__placeholder {
                    color: #7e8287;
                }
                /deep/ .ant-select-focused .ant-select-selection,
                /deep/ .ant-select-selection:focus,
                /deep/ .ant-select-selection:active,
                /deep/ .ant-select-selection:hover {
                    border-color: #dbdad8 !important;
                    border-right-width: 1px !important;
                    box-shadow: none !important;
                }
                /deep/ .ant-select-selection__choice {
                    background: #f4f3f3;
                    border-radius: 14px;
                    padding: 0 22px 0 12px;
                }
                /deep/
                    .ant-select-selection--multiple
                    .ant-select-selection__choice__remove:hover {
                    color: #8b3c22;
                }
                /deep/ .ant-select-arrow {
                    width: 9px;
                    height: 8px;
                    margin-top: -4px;
                    background-image: url('../../../../assets/image/student/stepFour/unitThree/down-default.png');
                }
                &.ant-select-open /deep/ .ant-select-arrow {
                    background-image: url('../../../../assets/image/student/stepFour/unitThree/down.png');
                }
            }
            .con-first {
                margin-bottom: 17px;
            }

            .con-second {
                background: #f9f9f9;
                padding: 12px 13px;
                .address-item {
                    display: inline-block;
                    line-height: 29px;
                    height: 29px;
                    background: #ecedef;
                    border-radius: 15px;
                    margin-right: 10px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #494e57;
                    padding: 0 15px;
                    margin-bottom: 12px;
                    .del-icon {
                        display: inline-block;
                        width: 12px;
                        height: 12px;
                        margin-left: 10px;
                        background-image: url('../../../../assets/image/student/stepFour/unitThree/del.png') !important;
                        background-size: cover;
                        vertical-align: -1px;
                        cursor: pointer;
                        &:hover {
                            background-image: url('../../../../assets/image/student/stepFour/unitThree/del-hover.png') !important;
                            background-size: cover;
                        }
                    }
                }
                .input-line {
                    display: inline-block;
                    margin-bottom: 12px;
                    .add-input {
                        width: 145px;
                        height: 29px;
                        line-height: 29px;
                        border: 0;
                        font-weight: 400;
                        font-size: 14px;
                        background: #ecedef;
                        border-radius: 15px;
                        color: #494e57;
                        padding-left: 15px;
                        &:hover,
                        &:focus {
                            outline: none;
                        }
                    }
                }
                .add-btn {
                    display: block;
                    width: max-content;
                    height: 32px;
                    line-height: 30px;
                    background: #fff3f2;
                    border-radius: 16px;
                    border: 1px solid #cc9d9a;
                    padding: 0 15px 0 18px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #a82822;
                    cursor: pointer;
                }
            }
        }
    }

    .level-line {
        padding: 25px 0 10px;
        font-weight: 400;
        font-size: 14px;
        color: #373536;
        &::before {
            content: '';
            display: inline-block;
            margin-right: 5px;
            width: 14px;
            height: 15px;
            background: url('../../../../assets/image/student/stepFour/unitFour/work.png')
                no-repeat center;
            background-size: cover;
            vertical-align: -2px;
        }
    }
    .level-table-box {
        width: 100%;
        margin-bottom: 30px;
    }
    .step-content {
        padding: 0 0 30px;
        .step-label {
            font-weight: bold;
            font-size: 14px;
            color: #ffffff;
            width: 100%;
            height: 32px;
            background: #b84b3c;
            line-height: 32px;
            padding: 0 15px;
        }
        .step-upload {
            padding-top: 16px;
            display: flex;
            align-items: center;
            .ant-btn {
                width: 92px;
                height: 32px;
                background: #fff3f2;
                border-radius: 16px;
                border: 1px solid #cc9d9a;
                text-align: center;
                line-height: 30px;
                font-size: 14px;
                color: #a82822;
                cursor: pointer;
                margin-right: 20px;
            }
            .upload-text {
                font-size: 12px;
                color: #9fa4aa;
            }
        }
        .file-list {
            display: flex;
            padding-top: 16px;
            gap: 22px;
            flex-wrap: wrap;
            .file-item {
                position: relative;
                width: 236px;
                cursor: pointer;
                .file-upper {
                    width: 100%;
                    height: auto;
                    aspect-ratio: 236/133;
                    position: relative;
                    overflow: hidden;
                    .file-cover {
                        width: 100%;
                        height: 100%;
                        transition: all 0.3s;
                        &.file-docx {
                            background: #e5ecfa;
                            &::before {
                                content: '';
                                display: inline-block;
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                width: 53px;
                                height: 63px;
                                background: url('../../../../assets/image/student/unitTwo/file-word.png')
                                    no-repeat center/cover;
                            }
                        }
                    }
                    .file-delete {
                        position: absolute;
                        top: 0;
                        right: 0;
                        width: 28px;
                        height: 28px;
                        background: rgba(255, 255, 255);
                        border-radius: 0px 0px 0px 14px;
                        border: 1px solid #cc9d9a;
                        transition: all 0.3s;
                        z-index: 2;
                        &::before {
                            content: '';
                            display: inline-block;
                            position: absolute;
                            top: 7px;
                            left: 7px;
                            background: url('../../../../assets/image/student/unitTwo/delete-red.png')
                                no-repeat center/cover;
                            width: 15px;
                            height: 15px;
                            transition: all 0.3s;
                        }
                    }
                    .file-button {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        color: #ffffff;
                        z-index: 1;
                        opacity: 0;
                    }
                    .file-mask {
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(60, 60, 62, 0.6);
                        transition: all 0.3s;
                        opacity: 0;
                    }
                    .file-progress {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 1;
                        /deep/ span {
                            font-weight: bold;
                            font-size: 12px;
                            color: #a82822;
                        }
                        /deep/ .ant-progress-inner {
                            background: #fff;
                        }
                    }
                    .file-translate {
                        width: 100%;
                        height: calc(100% + 2px);
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 1;
                        background: url('../../../../assets/image/student/unitTwo/uploaded.png')
                            no-repeat center/cover;
                        &.translate {
                            background: url('../../../../assets/image/student/unitTwo/translate.png')
                                no-repeat center/cover;
                        }
                    }
                }
                .file-name {
                    height: 62px;
                    background: #ffffff;
                    border: 1px solid #e7eaec;
                    font-size: 14px;
                    color: #3c3c3e;
                    padding: 9px 13px;
                    .name-txt {
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        word-break: break-all;
                        height: 40px;
                        line-height: 20px;
                    }
                }
                &:hover {
                    .file-upper {
                        .file-cover {
                            transform: scale(1.1);
                        }
                        .file-docx {
                            transform: scale(1) !important;
                        }
                        .file-delete {
                            background: linear-gradient(
                                90deg,
                                #c0403a 3%,
                                #bb1c15 100%
                            );
                            border: 1px solid #cc9d9a;
                            opacity: 0.94;
                            &::before {
                                background: url('../../../../assets/image/student/unitTwo/delete-white.png')
                                    no-repeat center/cover;
                            }
                        }
                        .file-mask {
                            opacity: 1;
                        }
                        .file-button {
                            opacity: 1;
                        }
                    }
                }
                // 转码中
                &.translate {
                    .file-mask {
                        opacity: 0;
                    }

                    &:hover {
                        .file-mask {
                            opacity: 1;
                        }
                    }
                }
                &.uploading {
                    .file-upper {
                        .file-mask {
                            opacity: 1;
                        }
                    }
                }
            }
        }
        .file-empty {
            margin-top: 10px;
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #d50715;
            &::before {
                content: '';
                display: inline-block;
                width: 14px;
                height: 14px;
                background: url('../../../../assets/image/student/unitTwo/empty.png')
                    no-repeat center/cover;
                margin-right: 6px;
            }
        }
    }
}

@media screen and (max-width: 1800px) {
    .step-outer-box .bottom-all-box .profile-item .profile-files .file-item {
        width: 50%;
        &:nth-child(3n)::after {
            display: block;
        }

        &:nth-child(2n)::after {
            display: none;
        }
    }
}
.disabled {
    opacity: 0.5;
    pointer-events: none;
    &.file-delete {
        display: none;
    }
}
/deep/ .ant-select-selection__placeholder {
    display: none !important;
}
</style>